import { RatingsSummary } from "../../account/models/ratings-summary";
import { Proposal } from "../../buy/models/proposal.model";
import { ProviderOfferHistory } from "../../car/models/provider-offer-history.model";
import { CarBusinessLine } from "../../car/constants/car-basic-data";
import { ServiceType } from "../../common/constants/common-basic-data";
import { Appointment } from "../../common/models/appointment.model";
import { Conversation } from "../../common/models/conversation.model";
import { GeoLocation } from "../../common/models/geo-location.model";
import { KeyEvent } from "../../common/models/key-event.model";
import { Price } from "../../common/models/string-data.model";
import { Booking } from "../../rent/models/booking.model";
import { CarJobCategory } from "../constants/keep-basic-data";
import { Job } from "./job.model";


export class KeepOffer {

   offerId = "";
   favorite: boolean = false;
   providerActive: boolean = false;

   businessLine: CarBusinessLine = CarBusinessLine.KEEP;
   jobCategories: CarJobCategory [] = [];

   providerId = "";
   providerName = "";
   providerType = "";
   providerCountry = "";
   providerBusinessName = "";
   providerRatingsSummary: RatingsSummary = new RatingsSummary();

   country = "";
   city = "";

   offerTitle = "";
   offerDescription = "";

   offerPosted = false;
   offerClosed = false;

   offerStartDate = "";
   offerEndDate = "";

   servicesProvided: ServiceType[] = [];
   specialtyMakes: string[] = [];

   mapLocation = "";
   geoLocation: GeoLocation = new GeoLocation("", 0, 0);

   buyPrice: Price = Price.getDefault();
   rentDayRate: Price = Price.getDefault();
   insuranceDayRate: Price = Price.getDefault();
   driverDayRate: Price = Price.getDefault();
   keepPrice: Price = Price.getDefault();

   buyPriceHistory: Price [] = [];
   rentDayRateHistory: Price [] = [];
   insuranceDayRateHistory: Price [] = [];
   driverDayRateHistory: Price [] = [];
   keepPriceHistory: Price [] = [];
   
   imagesFilenames: string[] = [];
   documentsFilenames: string[] = [];

   events: KeyEvent [] = [];
   history: ProviderOfferHistory[] = [];

   created = "";
   createdBy = "";
   lastUpdated = "";
   lastUpdatedBy = "";

   appointments: Appointment[] = [];
   proposals: Proposal[] = [];
   bookings: Booking[] = [];
   conversations: Conversation[] = [];
   jobs: Job[] = [];

   constructor(){
      this.history = []
      this.events = []

      this.servicesProvided = [];
      this.jobCategories = []
      this.specialtyMakes = [];
      this.geoLocation = new GeoLocation("", 0, 0);

      this.buyPriceHistory = [];
      this.rentDayRateHistory = [];
      this.insuranceDayRateHistory = [];
      this.driverDayRateHistory = [];
      this.keepPriceHistory = [];

      this.appointments = [];
      this.proposals = [];
      this.bookings = [];
      this.conversations = [];
      this.jobs = [];

      this.imagesFilenames = [];
      this.documentsFilenames = [];
   }

}
